export const fontFamily = "Work Sans";
export const secondaryFontFamily = "Poppins";
